module.exports = __webpack_public_path__ + "static/media/process-img3.ee8f46eb.webp";